import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import BoxIcon from '~/images/technology_box.svg';
import CardIcon from '~/images/technology_credit_card.svg';
import OrderIcon from '~/images/technology_custom_order.svg';
import PenIcon from '~/images/technology_design_pen.svg';
import { baseImgUrl } from '~/utils/constants';
import Button3D from '../shared/Button3D';

export default function TechnologyFirstCompany() {
  return (
    <Box sx={{ background: 'linear-gradient(180deg, #F8F5EE 77.76%, rgba(255, 255, 255, 0) 100%)' }}>
      <Container sx={{ py: 10 }}>
        <Stack flexDirection={{ xs: 'column', md: 'row' }} mb={10}>
          <Stack width={{ xs: '100%', md: '50%' }}>
            <Stack width={{ xs: '100%', md: '80%' }} mb={4}>
              <Typography variant="h4" mb={3}>
                Being Technology First Lets Us Put You First
              </Typography>
              <Typography variant="subtitle1">
                We leverage technology for you. SwagCharm offers comprehensive employee store options for your team.
                Integrate with our API and set up your store, we’ll handle the rest.
                <br />
                <br />
                We cover your:
              </Typography>
            </Stack>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Stack
                  direction="row"
                  flexWrap="nowrap"
                  bgcolor="#fff"
                  borderRadius="16px"
                  p="22px"
                  height="100%"
                >
                  <Typography variant="h6" fontSize="18px" fontWeight={700} width="100%">
                    Custom order creation
                  </Typography>
                  <img src={OrderIcon} alt="Box icon" width="36px" height="36px" style={{ marginLeft: '14px' }} />
                </Stack>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Stack
                  direction="row"
                  flexWrap="nowrap"
                  bgcolor="#fff"
                  borderRadius="16px"
                  p="22px"
                  height="100%"
                >
                  <Typography variant="h6" fontSize="18px" fontWeight={700} width="100%">
                    Payment services
                  </Typography>
                  <img
                    src={CardIcon}
                    alt="Credit card icon"
                    width="36px"
                    height="36px"
                    style={{ marginLeft: '14px' }}
                  />
                </Stack>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Stack
                  direction="row"
                  flexWrap="nowrap"
                  bgcolor="#fff"
                  borderRadius="16px"
                  p="22px"
                  height="100%"
                >
                  <Typography variant="h6" fontSize="18px" fontWeight={700} width="100%">
                    Customer employee design
                  </Typography>
                  <img src={PenIcon} alt="Pen icon" width="36px" height="36px" style={{ marginLeft: '14px' }} />
                </Stack>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Stack
                  direction="row"
                  flexWrap="nowrap"
                  bgcolor="#fff"
                  borderRadius="16px"
                  p="22px"
                  height="100%"
                >
                  <Typography variant="h6" fontSize="18px" fontWeight={700} width="100%">
                    Everything else from creation to shipping and delivery!
                  </Typography>
                  <img src={BoxIcon} alt="Box icon" width="36px" height="36px" style={{ marginLeft: '14px' }} />
                </Stack>
              </Grid>
            </Grid>
          </Stack>

          <Stack width={{ xs: '100%', md: '50%' }} pl={{ xs: 0, md: 9 }}>
            <img
              src={baseImgUrl + 'swagcharm-plane.png'}
              srcSet={`${baseImgUrl}swagcharm-plane.png, ${baseImgUrl}swagcharm-plane-2x.png 2x, ${baseImgUrl}swagcharm-plane-3x.png 3x`}
              alt="SwagCharm Technology First"
              width={500}
              height={500}
              style={{
                width: '100%',
                height: 'auto',
                minWidth: 'auto',
                minHeight: 'auto',
              }}
            />
          </Stack>
        </Stack>

        <Stack alignItems="center">
          <Typography variant="h5" textAlign="center" mb={4} width={{ xs: '100%', md: '65%' }}>
            Automate your employee store Swag across multiple platforms with SwagCharm’s Technology First approach.
          </Typography>

          <Button3D href="/shop">Shop Swag Now</Button3D>
        </Stack>
      </Container>
    </Box>
  );
}
